<template>
    <div>
        <h5>{{evaluation.name}}</h5>
        <hr>
        <AlertDismiss ref="alert" />
        <b-overlay :show="fetchingQuestions" class="overlay">
            <form v-if="answers" @submit.prevent="onSubmit">
                <div class="row">
                    <div v-for="(question, index) in questions" :key="question.id" class="mb-3 col-12 row">
                        <div class="col-auto">
                            <label>
                                {{ index + 1}}.
                                {{ question.text }}
                            </label>
                            <br>
                            <div class="form-group">
                              <div v-for="option in question.answers" :key="option.text" class="form-check my-0">
                                <input 
                                  type="radio"
                                  :id="option.id"
                                  :value="option.id"
                                  v-model="answers[question.id]"
                                  class="form-check-input"
                                  required
                                  :class="getClass(question.id)"
                                >
                                <small>
                                    <label :for="option.id" class="form-check-label text-option">
                                      {{ option.text }}
                                    </label>
                                </small>
                              </div>
                            </div>
                         </div>
                    </div>
                </div>
                <button class="btn btn-primary" type="submit" @click="markAttempted" :disabled="uploading">
                    <b-spinner v-if="uploading" small/>
                    Enviar
                </button>
            </form>
        </b-overlay>
    </div>
</template>

<script>
import AlertDismiss from '@/components/shared/Alert-dismiss.vue';
import { EventNames } from '@/plugins/enums';
import { mapActions } from 'vuex';

export default {
    name: 'EvaluationUserForm',

    props: {
        evaluation: Object,
        questions: Array
    },

    components: {
        AlertDismiss
    },

    data() {
        return {
            answers: null,
            attemptedSubmit: false,
            uploading: false
        }
    },

    computed: {
        fetchingQuestions() {
            return !this.questions
        }
    },

    mounted() {
        if (this.questions) {
            this.resetAnswers()
        }
    },

    methods: {
        ...mapActions(["sendEvaluation"]),

        async onSubmit(){
            this.uploading = true
            let payload = {
                evaluationId: this.evaluation.id,
                studentResponses: Object.entries(this.answers).map(([k, v]) => {
                    return {
                        questionId: k,
                        answerId: v
                    }
                })
            }

            let result = await this.sendEvaluation(payload)

            if (result.isError) {
                this.$refs.alert.showAlert(result.message, 'warning')
                this.uploading = false
                return
            }

            this.$eventBus.$emit(EventNames.SubmittedEvaluation, this.evaluation.id)
            this.resetAnswers()
            this.uploading = false
            
            this.attemptedSubmit = false
        },

        resetAnswers() {
            this.answers = this.questions.reduce((acc, question) => {
                acc[question.id] = null
                return acc
            }, {})
        },

        getClass(id) {
            return this.attemptedSubmit && !this.answers[id] ? 'is-invalid' : ''
        },

        markAttempted() {
            this.attemptedSubmit = true
        }
    },

    watch: {
        questions: {
            handler() {
                this.resetAnswers()
            },
            deep: true
        }
    }
}

</script>

<style scoped>
.overlay {
    min-height: 100px;
}

.text-option {
    white-space: normal;
    word-wrap: break-word;
    max-width: 100%;
    display: inline-block;
}

.form-check {
    margin-bottom: 10px;
}
</style>
